<template>
  <transition name="modal">
    <div class="modal-mask">
      <div v-loading="loading" class="modal-wrapper">
        <div class="row d-flex justify-content-center">
          <div class="col-md-6">

            <div class="card shadow">
              <div class="row px-3">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-center">
                    <h2 class="my-2">Request Change</h2>
                    <span class="has-interaction" @click="$emit('close')">
                      <i class="fa-lg fas fa-times"></i>
                    </span>
                  </div>
                  <div class="col-12">
                    <hr />
                  </div>
                </div>
              </div>

              <div class="row p-3">
                <div class="col-3">
                  <label>Requested Changes:</label>
                </div>
                <div class="col-9">
                  <textarea class="form-control" v-model="message" rows="5" placeholder="Enter the details of your requested change here"></textarea>
                </div>
              </div>

              <div class="row px-3">
                <div class="col-12">
                  <hr>
                </div>
              </div>

              <div class="row p-3">
                <div class="col-12 d-flex justify-content-end">
                  <button class="btn btn-primary" @click="handleSubmit">Send Request</button>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    business: {
      type: Object
    }
  },
  data() {
    return {
      //
      message: "",
      loading: false
    };
  },
  methods: {
    handleSubmit() {
      //
      this.loading = true;
      axios
        .post(
          `/api/v1/businesses/${this.business.id}/request-changes`,
          { message: this.message },
          {
            onUploadProgress: progressEvent => {
              console.log(
                "Upload Progress:" +
                  Math.round(
                    (progressEvent.loaded / progressEvent.total) * 100
                  ) +
                  "%"
              );
            }
          }
        )
        .then(res => {
          this.loading = false;

          this.$message({
            type: "success",
            message:
              "Your request was sent. Please allow Ottley Capital time to process"
          });
          this.$emit("close");
        })
        .catch(errors => {
          this.loading = false;
          var errorText = "";
          _.forEach(errors.response.data.errors, function(value) {
            errorText += "" + value + " ";
          });
          this.$message({
            type: "error",
            message: errorText
          });
          this.form.errors.record(errors.response.data.errors);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 1950;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  width: 600px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}
.modal-body {
  margin: 20px 0;
}
.modal-default-button {
  float: right;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
